import React from "react";
import { connect } from 'react-redux';
import Button from "../Button";
import { authShowLogin, authShowRegister } from '../../actions/creators';
import NoContentMessage from "../common/NoContentMessage";

interface Props {
    buttons?: React.ReactNode,
    children: React.ReactNode,
    icon?: string,
    openLogin: Function,
    openRegister: Function
}

const RequireAuthMessage: React.FC<Props> = (props) => {
    const onLoginClick = (e: React.MouseEvent) => {
        e.preventDefault();
        props.openLogin();
    }

    const onRegisterClick = (e: React.MouseEvent) => {
        e.preventDefault();
        props.openRegister();
    }

    return <NoContentMessage icon={`fa-light ${props.icon || 'fa-ticket'}`}>
        <div className="mt-5">{props.children}</div>
        {props.buttons
            ? props.buttons
            : <>
                <Button block onClick={onLoginClick} to="/login" className='mb-3'>Iniciar sesión</Button>
                <Button block primary onClick={onRegisterClick} to="/registro">Registrarme</Button>
            </>}
    </NoContentMessage>;
}

const mapDispatchToProps = dispatch => ({
    openLogin: () => dispatch(authShowLogin()),
    openRegister: () => dispatch(authShowRegister()),
});

export default connect(
    null,
    mapDispatchToProps
)(RequireAuthMessage);